import { forwardRef } from "react";
import styles from "./Button.module.scss";
import { Button as NextUiButton } from "@nextui-org/button";
import LoadingDots from "../LoadingDots/LoadingDots";
import { ButtonProps as NextUIButtonProps } from "@nextui-org/button";
import { colors } from "../../styles/_variables";

export interface Props
  extends Omit<NextUIButtonProps, "variant" | "color" | "size"> {
  /**
   * The content to display in the button
   */
  text: React.ReactNode | string;
  /**
   * The button appearance style
   */
  variant?: "primary" | "secondary" | "tertiary";
  /**
   * The button size
   */
  size?: "desktop" | "mobile";
  /**
   * Custom style
   */
  className?: string;
  /**
   * Is Allaria+
   */
  isAllariaMas?: boolean;
}

const Button = forwardRef<HTMLButtonElement, Props>(
  (
    {
      text,
      isLoading,
      className,
      variant = "primary",
      size = "desktop",
      disableRipple = true,
      disableAnimation = true,
      isAllariaMas,
      ...rest
    },
    ref
  ) => {
    const {
      primary,
      secondary,
      tertiary,
      loadingButton,
      mobileButton,
      allariaMas,
    } = styles;

    const variantsStyles = {
      primary,
      secondary,
      tertiary,
    };

    const variantsLoadingStyles = {
      primary: colors.white,
      secondary: colors.primary[300],
      tertiary: colors.primary[300],
    };

    return (
      <NextUiButton
        {...rest}
        ref={ref} // Forward the ref to the NextUiButton component
        aria-expanded="false"
        disableAnimation={disableAnimation}
        disableRipple={disableRipple}
        className={`
        ${isAllariaMas ? allariaMas : ""}
        ${variantsStyles[variant]} 
        ${isLoading ? loadingButton : ""} 
        ${size === "mobile" ? mobileButton : ""} 
        ${className || ""}`}
      >
        {isLoading ? (
          <LoadingDots color={variantsLoadingStyles[variant]} />
        ) : (
          text
        )}
      </NextUiButton>
    );
  }
);

export default Button;
